module.exports = __webpack_public_path__ + "static/media/mc_union_pay.png";